import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Locations } from "../locations/location.entity";
import { SkuCodes } from "../sku-codes/sku-codes.entity";
import { ZoneMaster } from "../zone-master/zone-master.entity";

@Entity('rm_columns')
export class RmColumns {

  @PrimaryGeneratedColumn("increment", { name: 'columns_id' })
  columnsId?: number;

  @Column("varchar", {
    nullable: false,
    length: 20,
    name: "columns_code"
  })
  columnsCode: string;

  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "columns_no"
  })
  columnsNo: number;

  

  @Column("boolean", {
    nullable: false,
    name: "isActive",
    default:true
  })
  isActive: boolean | null;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  // @ManyToOne(type =>ZoneMaster, zoneMaster => zoneMaster.columnsInfo, { nullable: false, })
  // @JoinColumn({ name: "zone_id" })
  // zoneMasterInfo: ZoneMaster;

  @OneToMany(type=>Locations, Column=>Column.columnId,{cascade: true})
  locationinfo:Locations[];
 




}



